/**
 * Состояние входа. Вошёл пользователь или нет, знает только сервер: сессия лежит в HttpOnly-cookie,
 * и страница её не видит. Поэтому до ответа /auth/me не рисуется ни дашборд, ни форма входа.
 * Раньше интерфейс верил токену из localStorage и успевал показать дашборд до первого 401.
 */
export const AUTH_STATUS = Object.freeze({
  CHECKING: 'checking',
  AUTHENTICATED: 'authenticated',
  ANONYMOUS: 'anonymous',
  UNAVAILABLE: 'unavailable'
});

export const CHECKING_SESSION = Object.freeze({ status: AUTH_STATUS.CHECKING, user: null });
export const ANONYMOUS_SESSION = Object.freeze({ status: AUTH_STATUS.ANONYMOUS, user: null });
export const UNAVAILABLE_SESSION = Object.freeze({ status: AUTH_STATUS.UNAVAILABLE, user: null });

export const authenticatedSession = (user) => ({ status: AUTH_STATUS.AUTHENTICATED, user });

/**
 * Только 401 значит «не вошёл». 5xx и обрыв связи — это API, который лежит (идут миграции, перенос
 * аналитики, обновление стенда), и показать там форму входа значило бы предложить войти в неработающий
 * сервер и молча разлогинить всех на время обновления.
 *
 * @param {() => Promise<object>} fetchCurrentUser
 */
export const resolveSession = async (fetchCurrentUser) => {
  try {
    return authenticatedSession(await fetchCurrentUser());
  } catch (error) {
    return error?.response?.status === 401 ? ANONYMOUS_SESSION : UNAVAILABLE_SESSION;
  }
};

const RETRY_BASE_MS = 2000;
const RETRY_MAX_MS = 30000;

/** Пауза перед повторной проверкой: сервер, поднимающийся после обновления, не надо заваливать запросами. */
export const sessionRetryDelayMs = (attempt) => Math.min(RETRY_BASE_MS * 2 ** attempt, RETRY_MAX_MS);

// Ключи прежней схемы: токен в localStorage был доступен любому скрипту страницы и больше не нужен.
export const LEGACY_AUTH_STORAGE_KEYS = Object.freeze(['callcenter::authToken', 'callcenter::authUser']);

export const clearLegacyAuthStorage = () => {
  try {
    LEGACY_AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  } catch {
    // Хранилище бывает недоступно, и тогда убирать нечего.
  }
};
